import { btn, field, table, text } from '../ui';
import { removePtoEntry, sortPtoEntries } from '../schedule.mjs';

export default function PtoPanel({
  ptoEntries,
  setPtoEntries,
  savePtoToBackend,
  allMembers,
  newPtoName,
  setNewPtoName,
  newPtoStart,
  setNewPtoStart,
  newPtoEnd,
  setNewPtoEnd,
  addPTO,
}) {
  return (
    <div>
      <h2 className="text-lg font-semibold mb-3">PTO Tracking</h2>
      <div className="flex gap-2 mb-4 items-end flex-wrap">
        <label className="text-sm">
          Name:
          <select value={newPtoName} onChange={(e) => setNewPtoName(e.target.value)} className={field.inputInline}>
            <option value="">Select...</option>
            {allMembers.map((name, idx) => <option key={idx} value={name}>{name}</option>)}
          </select>
        </label>
        <label className="text-sm">
          From:
          <input type="date" value={newPtoStart} onChange={(e) => setNewPtoStart(e.target.value)} className={field.inputInline} />
        </label>
        <label className="text-sm">
          To:
          <input type="date" value={newPtoEnd} onChange={(e) => setNewPtoEnd(e.target.value)} className={field.inputInline} />
        </label>
        <button
          onClick={() => {
            addPTO(newPtoName, newPtoStart, newPtoEnd);
            setNewPtoName(''); setNewPtoStart(''); setNewPtoEnd('');
          }}
          className="bg-orange-500 text-white px-3 py-1 rounded text-sm hover:bg-orange-600"
        >
          Add PTO
        </button>
      </div>

      {ptoEntries.length === 0 ? (
        <p className="text-gray-500 text-sm">No PTO entries.</p>
      ) : (
        <div>
          <table className="border-collapse text-sm w-full">
            <thead>
              <tr className="bg-gray-100">
                <th className={table.cellHead}>Name</th>
                <th className={table.cellHead}>Date</th>
                <th className={table.cell}></th>
              </tr>
            </thead>
            <tbody>
              {sortPtoEntries(ptoEntries).slice(0, 20).map((entry) => (
                <tr key={`${entry.name}-${entry.date}`}>
                  <td className={table.cell}>{entry.name}</td>
                  <td className={table.cell}>{entry.date}</td>
                  <td className={table.cell}>
                    <button
                      onClick={() => {
                        const newPto = removePtoEntry(ptoEntries, entry);
                        setPtoEntries(newPto);
                        savePtoToBackend(newPto);
                      }}
                      className={btn.danger}
                    >
                      ✕
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {ptoEntries.length > 20 && <p className={text.hintTight}>Showing 20 of {ptoEntries.length}</p>}
          <button
            onClick={() => { setPtoEntries([]); savePtoToBackend([]); }}
            className="mt-2 text-xs text-gray-500 hover:text-gray-700"
          >
            Clear all PTO
          </button>
        </div>
      )}
    </div>
  );
}
